<template>
  <layout-component>
    NOT FOUND
  </layout-component>
</template>
<script lang="ts" setup>
import LayoutComponent from './layout.component.vue';
</script>